import { render, staticRenderFns } from "./plans-list.vue?vue&type=template&id=bef60970"
import script from "./plans-list.vue?vue&type=script&lang=js"
export * from "./plans-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports